<template>
  <Main>
    <v-container>
      <v-card class="mx-auto">
        <v-card-text>
          <p class="display-1 text--primary">
            Upload Target
            <v-btn small color="warning" @click="downloadCSV()"
              >Download Excel Template</v-btn
            >
          </p>
          <div class="text--primary">
            <!-- {{ this.SELECTED_MONTH_PERIOD + " - " + this.SELECTED_YEAR_PERIOD + " - " + this.SELECTED_BRANCH}} -->
            <!-- {{ this.VSELECT_BRANCH }} -->
            <v-row>
              <v-col md="12" sm="12">
                <!-- {{ "CSV : " + this.JSON_FILE_UPLOAD }} -->
                <v-file-input
                  v-model="JSON_FILE_UPLOAD"
                  color="red darken-1"
                  counter
                  label="File input"
                  placeholder="Select your files"
                  prepend-icon="mdi-paperclip"
                  outlined
                  :show-size="1000"
                  @change="onAddFiles($event)"
                >
                  <template v-slot:selection="{ index, text }">
                    <v-chip
                      v-if="index < 2"
                      color="deep-purple accent-4"
                      dark
                      label
                      small
                    >
                      {{ text }}
                    </v-chip>

                    <span
                      v-else-if="index === 2"
                      class="overline grey--text text--darken-3 mx-2"
                    >
                      +{{ files.length - 2 }} File(s)
                    </span>
                  </template>
                </v-file-input>
                
                <FilePond
                  name="test"
                  ref="pond"
                  class-name="my-pond"
                  label-idle="Click or Drop files here..."
                  accepted-file-types="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, text/csv, application/csv"
                  :files="this.JSON_FILE_UPLOAD"
                  :init="handleFilePondInit"
                  v-on:updatefiles="handleFilePondUpdateFile"
                  v-on:removefile="handleFilePondRemoveFile"
                />
              </v-col>
              <v-col md="12">
                <!-- {{ this.dtItems}} -->
                <v-row>
                  <v-col md="12" justify="right">
                    <v-btn
                      class="mb-3 float-right"
                      small
                      color="warning"
                      @click="confirmModal(submitUpload)"
                      >Submit Data Target</v-btn
                    >
                  </v-col>
                  <v-col md="12">
                    <v-data-table
                      :headers="dtHeaders"
                      :items="dtItems"
                      :search="search"
                      v-bind:allow-multiple="false"
                      :loading="dtLoading"
                      loading-text="Fetching Data..."
                    ></v-data-table>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
    </v-container>
    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>{{ snackbarText }}</v-snackbar>
    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- Start Validation Submit -->
    <v-dialog v-model="isOpenModalConfirm" max-width="500px">
      <v-card>
        <v-card-title class="headline">Are you Sure to Continue ?</v-card-title>

        <v-card-text
          >It will submit all data which is imported to database. Please give
          confirmation before you submit.</v-card-text
        >

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" text @click="isOpenModalConfirm = false"
            >Cancel</v-btn
          >

          <v-btn color="green darken-1" text @click="methodAction"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End Validation Submit -->
  </Main>
</template>

<script>
import Main from "@/Main.vue";
import XLSX from "xlsx";

// Import the plugin code
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";

// Import Vue FilePond
import vueFilePond, { setOptions } from "vue-filepond";

// Import FilePond styles
import "filepond/dist/filepond.min.css";

// Create component
const FilePond = vueFilePond(FilePondPluginFileValidateType);

setOptions({
  allowMultiple: false,
});

const JSON_FOR_DOWNLOAD = [
  {
    YEAR_ID: "",
    MONTH_ID: "",
    KODE_CABANG: "",
    LINI_ID: "",
    SUBLINI_OR_PRODUCT: "",
    CHANNEL_OUTLET_GROUP: "",
    SALESPERSON_POSITION: "",
    TERRITORY_GEO_GROUP: "",
    SUM_OF_TARGET_REKOMENDASI_HO: "",
    SUM_OF_TARGET_CABANG: "",
  },
];

export default {
  components: {
    Main,
    FilePond,
  },
  data() {
    return {
      methodAction: "",
      isOpenModalConfirm: false,
      JSON_FILE_UPLOAD: [],
      search: "",
      dtLoading: false,
      dtHeaders: [
        {
          text: "MONTH_ID",
          value: "TGT_MONTH_ID",
        },
        {
          text: "YEAR_ID",
          value: "TGT_YEAR_ID",
        },
        {
          text: "KODE_CABANG",
          value: "BRANCH_CODE",
        },
        {
          text: "SALESPERSON_POSITION",
          value: "ROLE_POSITION_CODE",
        },
        {
          text: "LINI_ID",
          value: "LINI_ID",
        },
        {
          text: "SUBLINI_OR_PRODUCT",
          value: "SUBLINI_OR_PRODUCT",
        },
        {
          text: "TERRITORY_GEO_GROUP",
          value: "TERITORY_GEO_GROUP",
        },
        {
          text: "CHANNEL_OUTLET_GROUP",
          value: "OUTLET_CHANNEL_GROUP",
        },
        {
          text: "SUM_OF_TARGET_REKOMENDASI_HO",
          value: "VALUE_TGT_HO",
        },
        {
          text: "SUM_OF_TARGET_CABANG",
          value: "VALUE_TGT_CAB",
        },
      ],
      dtItems: [],
      isShowSnackbar: false,
      snackbarText: "",
      isLoading: false,
    };
  },
  methods: {
    confirmModal: function (method) {
      this.isOpenModalConfirm = true;
      this.methodAction = method;
    },
    handleFilePondInit() {},
    handleFilePondUpdateFile(file) {
      let self = this;
      let counter = true;

      const UPLOADED_CSV = file.map((fileItems) => fileItems.file);
      const userData = JSON.parse(localStorage.getItem("userData"));

      var files = UPLOADED_CSV,
        f = files[0];

      if (f) {
        var reader = new FileReader();
        reader.onload = (e) => {
          var data = new Uint8Array(e.target.result);
          var workbook = XLSX.read(data, {
            type: "array",
          });
          let sheetName = workbook.SheetNames[0];
          /* DO SOMETHING WITH workbook HERE */
          let worksheet = workbook.Sheets[sheetName];
          const XLSXJSON = XLSX.utils.sheet_to_json(worksheet);
          self.dtItems = [];
          if (self.dtItems < 1) {
            for (let XLSXJSONDATA of XLSXJSON) {
              if (
                XLSXJSONDATA.YEAR_ID != undefined &&
                XLSXJSONDATA.MONTH_ID != undefined &&
                XLSXJSONDATA.KODE_CABANG != undefined &&
                XLSXJSONDATA.LINI_ID != undefined &&
                XLSXJSONDATA.SUBLINI_OR_PRODUCT != undefined &&
                XLSXJSONDATA.CHANNEL_OUTLET_GROUP != undefined &&
                XLSXJSONDATA.SALESPERSON_POSITION != undefined &&
                XLSXJSONDATA.TERRITORY_GEO_GROUP != undefined &&
                XLSXJSONDATA.SUM_OF_TARGET_REKOMENDASI_HO != undefined &&
                XLSXJSONDATA.SUM_OF_TARGET_CABANG != undefined
              ) {
                self.dtItems.push({
                  TGT_YEAR_ID: XLSXJSONDATA.YEAR_ID,
                  TGT_MONTH_ID: XLSXJSONDATA.MONTH_ID,
                  BRANCH_CODE: XLSXJSONDATA.KODE_CABANG,
                  LINI_ID: XLSXJSONDATA.LINI_ID,
                  SUBLINI_OR_PRODUCT: XLSXJSONDATA.SUBLINI_OR_PRODUCT,
                  OUTLET_CHANNEL_GROUP: XLSXJSONDATA.CHANNEL_OUTLET_GROUP,
                  ROLE_POSITION_CODE: XLSXJSONDATA.SALESPERSON_POSITION,
                  TERITORY_GEO_GROUP: XLSXJSONDATA.TERRITORY_GEO_GROUP,
                  VALUE_TGT_HO: XLSXJSONDATA.SUM_OF_TARGET_REKOMENDASI_HO,
                  VALUE_TGT_CAB: XLSXJSONDATA.SUM_OF_TARGET_CABANG,
                  USERIDUPDATE: userData.USER_ID,
                });
              }
            }
          }

          // console.log(self.dtItems);
        };
        reader.readAsArrayBuffer(f);
      }
    },
    handleFilePondRemoveFile(error, file) {
      this.$refs.pond.removeFile();
      this.dtItems = [];
    },
    onAddFiles(event) {
      try {
        let self = this;
        let file = event;
        const userData = JSON.parse(localStorage.getItem("userData"));
        const reader = new FileReader();
        this.dtItems = [];
        this.disableSubmit = false;

        reader.onload = (e) => {
          var data = new Uint8Array(e.target.result);
          var workbook = XLSX.read(data, {
            type: "array",
            cellDates: true,
          });

          console.log("file.type : ", file.type);

          let sheetName = workbook.SheetNames[0];
          /* DO SOMETHING WITH workbook HERE */
          let worksheet = workbook.Sheets[sheetName];
          const XLSXJSON = XLSX.utils.sheet_to_json(worksheet);

          console.log("XLSXJSON : ", XLSXJSON);

          for (let XLSXJSONDATA of XLSXJSON) {
            if (
              XLSXJSONDATA.CUSTOMER_ID_REF != undefined &&
              XLSXJSONDATA.CUSTOMER_NAME != undefined &&
              XLSXJSONDATA.BISNIS != undefined &&
              XLSXJSONDATA.TYPE_DESC != undefined &&
              XLSXJSONDATA.POSITION != undefined &&
              XLSXJSONDATA.ADD_SALESMAN_POSITION != undefined &&
              XLSXJSONDATA.START_DATE != undefined
            ) {
              console.log("XLSXJSONDATA : ", XLSXJSONDATA);
              this.isLoading = true;
              let START_DATE = "";

              if (file.type == "application/vnd.ms-excel") {
                START_DATE = moment(new Date(XLSXJSONDATA.START_DATE)).format(
                  "YYYY-MM-DD"
                );
                self.dtItems.push({
                  CUSTOMERIDREF: XLSXJSONDATA.CUSTOMER_ID_REF,
                  CUSTOMERNAME: XLSXJSONDATA.CUSTOMER_NAME,
                  BISNIS: XLSXJSONDATA.BISNIS,
                  TYPEDESC: XLSXJSONDATA.TYPE_DESC,
                  POSITIONCODE: XLSXJSONDATA.POSITION,
                  ADDSALESMANPOSITION:
                    XLSXJSONDATA.ADD_SALESMAN_POSITION != undefined
                      ? XLSXJSONDATA.ADD_SALESMAN_POSITION
                      : "NA",
                  STARTDATE: START_DATE,
                  IS_VALID: "Y",
                  ASSIGNMENTUSERIDUPDATE: userData.USER_ID,
                });
              } else if (
                file.type ==
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              ) {
                // START_DATE = moment(new Date(XLSXJSONDATA.START_DATE))
                //   .add(1, "days")
                //   .format("YYYY-MM-DD");
                self.isLoading = false;
                self.isOpenModalConfirm = false;
                self.showSnackbar("Gunakan template XLS");
              }
            }
          }
          console.log("SELF DTITEMS : ", self.dtItems);
          if (self.dtItems.length > 0) {
            self.isOpenModalConfirm = false;
            self.isLoading = true;
            self.$http
              .post("/mapping-sales-assignment/validation", {
                excelData: self.dtItems,
                orgID: userData.ORG_ID,
              }, {
                headers: {
                  "api-key": this.$apiKey
                }
              })
              .then((res) => {
                const { success, data, message } = res.data;
                let valid = true;
                let reason = "";
                console.log("VALIDATION DATA : ", data);
                if (success) {
                  console.log("MASUK IF SUCCESS");
                  self.isLoading = false;

                  if (data.success) {
                    data.success.forEach((obj, index) => {
                      data.success[index].START_DATE = moment(
                        data.success[index].START_DATE
                      ).format("MM/DD/YYYY");

                      data.success[index].END_DATE = moment(
                        new Date(data.success[index].END_DATE)
                      ).format("MM/DD/YYYY");
                      data.success[index].ASSIGNMENT_LAST_UPDATE = moment(
                        new Date(data.success[index].ASSIGNMENT_LAST_UPDATE)
                      ).format("MM/DD/YYYY");
                    });
                  }

                  if (data.failed[0] != undefined) {
                    if (
                      data.failed[0].REASON == "Start Date tidak sesuai." ||
                      data.failed[0].REASON == "Branch/Position tidak sesuai."
                    ) {
                      console.log("MASUK IF data.failed[0] != undefined");
                      valid = false;
                      self.JSON_FILE_UPLOAD = [];
                      self.showSnackbar(data.failed[0].REASON);
                    } else {
                      console.log("MASUK ELSE IF data.failed[0] != undefined");

                      if (data.failed) {
                        data.failed.forEach((obj, index) => {
                          data.failed[index].START_DATE = moment(
                            new Date(data.failed[index].START_DATE)
                          ).format("MM/DD/YYYY");
                          data.failed[index].END_DATE = moment(
                            new Date(data.failed[index].END_DATE)
                          ).format("MM/DD/YYYY");
                          data.failed[index].ASSIGNMENT_LAST_UPDATE = moment(
                            new Date(data.failed[index].ASSIGNMENT_LAST_UPDATE)
                          ).format("MM/DD/YYYY");
                        });
                      }
                      self.dtItemsSuccess = data.success;
                      self.dtItemsFail = data.failed;
                      self.showSnackbar(message);
                    }
                  } else {
                    console.log("MASUK ELSE data.failed[0] != undefined");
                    self.isLoading = false;
                    self.dtItemsSuccess = data.success;
                    self.dtItemsFail = data.failed;
                    self.showSnackbar(message);
                  }
                } else {
                  console.log("MASUK ELSE res.data.success");
                  self.isLoading = false;
                  self.showSnackbar(message);
                }
              })
              .catch((err) => {
                self.isLoading = false;
                console.log(err.toString());
                self.showSnackbar(err.toString());
              });
          } else {
            self.isLoading = false;
            self.isOpenModalConfirm = false;
            // Edited By Dedian 29 Juli 2021 //
            self.showSnackbar("Gunakan template XLS");
          }
        };

        if (file) {
          reader.readAsArrayBuffer(file);
        }
      } catch (e) {
        this.isLoading = false;
        this.isOpenModalConfirm = false;
        this.showSnackbar(e);
      }
    },
    submitUpload() {
      if (this.dtItems.length > 0) {
        const USER_DATA = JSON.parse(localStorage.getItem("userData"));
        let data = {
          DATA_TARGET: this.dtItems,
          USER_ID: USER_DATA.USER_ID_UPDATE,
        };

        this.isLoading = true;
        this.isOpenModalConfirm = false;

        this.$http
          .post("/target/upload", data, {
            headers: {
              "api-key": this.$apiKey
            }
          })
          .then((res) => {
            console.log(res);
            const { success, message, data } = res.data;
            if (success) {
              this.isLoading = false;
              this.dtItems = [];
              this.$refs.pond.removeFile();
              this.showSnackbar(
                "Success for " +
                  data.SUCCESS_UPLOADED +
                  " data(s) and Failed for " +
                  data.FAIL_UPLOADED +
                  " data(s)  " +
                  data.REASON
                  ? "because " + data.REASON
                  : "" + " !"
              );
            } else {
              this.isLoading = false;
              this.isOpenModalConfirm = false;
              this.showSnackbar(message);
            }
          })
          .catch((err) => {
            this.isLoading = false;
            this.isOpenModalConfirm = false;
            this.showSnackbar(err.toString());
          });
      } else {
        this.isLoading = false;
        this.isOpenModalConfirm = false;
        this.showSnackbar("Please Upload CSV File First !");
      }
    },
    downloadCSV() {
      const workBook = XLSX.utils.book_new(); // create a new blank book
      const workSheet = XLSX.utils.json_to_sheet(JSON_FOR_DOWNLOAD);
      XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
      XLSX.writeFile(workBook, "Template Target.xls"); // initiate a file download in browser
    },
    showSnackbar(text) {
      this.snackbarText = text;
      this.isShowSnackbar = true;
    },
  },
};
</script>
